import styled, { css } from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";
import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const { carbon, blue } = colorsPalettes;

const TRANSITION_TIME = 150;

const baseItemContainerStyles = css`
    gap: 8px;
    padding: 8px;

    width: max-content;
    height: 52px;

    border-radius: 8px;
    align-items: center;

    background: ${carbon[25]};
`;

export const NameText = styled(Text)`
    color: ${carbon[500]};
    transition: color ${TRANSITION_TIME}ms ease-in-out;

    text-wrap: nowrap;
`;
export const CompetitorsText = styled(Text)`
    color: ${carbon[400]};
    transition: color ${TRANSITION_TIME}ms ease-in-out;

    text-wrap: nowrap;
`;
export const InfoContainer = styled(Flex)`
    gap: 4px;
    align-items: center;
    flex-shrink: 0;

    color: ${carbon[0]};
`;

export const IconsContainer = styled(Flex)`
    gap: 4px;
    align-items: center;
    flex-shrink: 0;
`;

export const IconContainer = styled(Flex)`
    align-items: center;

    padding: 8px;
    width: 32px;
    height: 32px;

    color: ${carbon[500]};

    border-radius: 6px;
    border: 1px solid ${carbon[50]};
    background-color: ${carbon[0]};

    transition:
        color ${TRANSITION_TIME}ms ease-in-out,
        border-color ${TRANSITION_TIME}ms ease-in-out;
`;

export const ItemContainer = styled(Flex)<{ $active?: boolean; $isLoading?: boolean }>`
    ${baseItemContainerStyles};

    cursor: pointer;

    transition:
        box-shadow ${TRANSITION_TIME}ms ease-in-out,
        background-color ${TRANSITION_TIME}ms ease-in-out;

    .webIcon,
    ${IconContainer} {
        transition: border-color ${TRANSITION_TIME}ms ease-in-out;
    }

    ${({ $active, $isLoading }) =>
        !$active &&
        !$isLoading &&
        `
        &:hover {
            ${setElevation("Z1")};

            ${NameText}, ${CompetitorsText} {
                color: ${blue[400]};
            }

            .webIcon, ${IconContainer} {
                border-color: ${blue[400]};
            }
        }
    `}
    ${({ $active }) =>
        $active &&
        `
        background: ${blue[400]};
        
        ${NameText}, ${CompetitorsText} {
            color: ${carbon[0]};
        }
        
        .webIcon, ${IconContainer} {
            border-color: ${blue[400]};
        }
    `}
        .iconLoader {
        border-radius: 6px;
    }
`;

export const EmptyProjectContainer = styled(Flex)`
    ${baseItemContainerStyles};
    border: 1px solid ${carbon[50]};

    ${IconContainer} {
        border-color: ${blue[400]};
        color: ${blue[400]};
    }

    ${NameText}, ${InfoContainer}, ${CompetitorsText} {
        color: ${blue[400]};
    }

    .emptyItemCountry svg path {
        fill: ${blue[400]};
    }
`;

export const IconButton = styled.button`
    display: flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
`;

export const Splitter = styled.div`
    height: 9px;
    width: 1px;
    background-color: ${blue[350]};
`;

export const ViewButton = styled(Button)`
    background-color: ${carbon[0]};
    text-wrap: nowrap;
    margin-left: auto;
`;

export const StyledCountryIcon = styled(SWReactCountryIcons)<{ $isWorldWide?: boolean }>`
    ${({ $isWorldWide }) =>
        $isWorldWide &&
        `
        svg path {
          fill: ${carbon[0]};
          }
       `}
`;

export const TooltipBody = styled.div`
    width: fit-content;
    white-space: pre-line;
`;
